// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.user-list-container[data-v-557307c0] {\r\n  padding: 20px;\n}\n.search-card[data-v-557307c0] {\r\n  margin-bottom: 20px;\n}\n.table-card[data-v-557307c0] {\r\n  margin-bottom: 20px;\n}\n.pagination[data-v-557307c0] {\r\n  margin-top: 20px;\r\n  text-align: right;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
